import React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "../../../Utils/index";
import { getAdBannerByDomainAction } from "../../../Store/actions";
import "../../../Assets/Scss/Scrollslider.scss";

const Scrollslider = (arg) => {
  const dispatch = useDispatch();

  const { adBanners } = useSelector((state) => state.Website);
  useEffect(() => {
    dispatch(getAdBannerByDomainAction());
  }, [dispatch]);

  const items = React.useMemo(() => {
    let arr = [];
    adBanners?.forEach((i) => {
      if (i.banner_dimension === "300 * 250") {
        let obj = {};
        obj.src = getImageUrl(i.image_upload);
        obj.url = i.image_url;
        obj.altText = "ad";
        arr.push(obj);
      }
    });
    return arr;
  }, [adBanners]);

  const items2 = React.useMemo(() => {
    let arr = [];
    adBanners?.forEach((i) => {
      if (i.banner_dimension === "728 * 90") {
        let obj = {};
        obj.src = getImageUrl(i.image_upload);
        obj.url = i.image_url;
        obj.altText = "ad";
        arr.push(obj);
      }
    });
    return arr;
  }, [adBanners]);

  return (
    <div id="hide-in-mobile-h3">
      <section id="anniversaryColl"  style={{margin:"5px 0", padding:"0"}}>
        <div id="anniversaryCollDiv">
          <div id="anniversaryCollScrollDiv"></div>
          <div id="imgDiv">
            {items.map((o) => {
              return (
                <img
                  id="scrollimg"
                  onClick={() =>
                    window.open(o?.desktop_redirect_url,
                      "_blank"
                    )
                  }
                  src={o.url || o.src}
                  alt={o.alt}
                />
              );
            })}
          </div>

          <div className="imagescroll">
             {items2.map((o) => {
               
              return (
                <img
                id="scrollimg2"
                  onClick={() =>
                    window.open(o?.mobile_redirect_url,
                      "_blank"
                    )
                  }
                  src={o.url || o.src}
                  alt={o.alt}
                />
    
              );
            })} 
          </div>
        </div>
      </section>
    </div>
  );
};

export default Scrollslider;
